export const urls = {
    base: 'https://rokdim.co.il/assets',
    publicationFlyer: 'publications_flayers',
    banners_pictures: 'banners_pictures',
    sessionsPictures: 'sessions_pictures',
    newspaperThumbnails: 'newspaper_thumbnails',
    newspaperPdf: 'newspaper_pdfs',
}
